module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-5"
  }, [_c('div', {
    staticClass: "col-xs-12 text-xs-left"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('YOUR_ACCOUNT_IS_INACTIVE')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('DEACTIVATION_DATE')) + " " + _vm._s(_vm.dateDeactivated))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('TO_USE_BRASTER_YOU_NEED_ACTIVE_ACCOUNT')))]), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-4 mb-5"
  }, [_c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('ACTIVATE_ACCOUNT')) + "\n            ")])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('ACTIVE_ACCOUNT_IS')))]), _vm._v(" "), _c('table', {
    staticClass: "mb-5"
  }, [_c('tr', [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/ico-ok-green.png")
    }
  }), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('ACCESS_TO_YOUR_EXAMINATION_RESULTS')))])]), _vm._v(" "), _c('tr', [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/ico-ok-green.png")
    }
  }), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('INFORMATION_ABOUT_EXAMINATIONS_TO_USE')))])]), _vm._v(" "), _c('tr', [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/ico-ok-green.png")
    }
  }), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('EVERY_MONTH_EXAMINATION_REMINDER')))])])])]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    staticClass: "unlock-request-modal",
    on: {
      "close": function($event) {
        return _vm.$router.push({
          name: 'logowanie'
        })
      }
    }
  }, [_c('survey-step5-q1', {
    attrs: {
      "single": true,
      "unlockRequest": true
    },
    on: {
      "sendUnlockRequest": _vm.sendUnlockRequest
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de2ec478","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/banned-account/banned-account.vue
// module id = 1245
// module chunks = 0